/* oxlint-disable lingui/no-unlocalized-strings */
import { retrieveBrowserLocale } from "@/utils/i18n";
import { useUserProfile } from "@/utils/useUserProfile";

export const useTallyFormId = () => {
  const { organization } = useUserProfile();

  const useTallyFormIdByOrganization = (() => {
    switch (organization) {
      case "capioahc":
        return "q4NyO2";
      case "rakus":
        // For Russian patients, show the Russian feedback form
        if (retrieveBrowserLocale() === "ru") {
          return "D4WL5b";
        }
        // Default: Latvian
        return "rjqXVM";
      case "medoma":
        return "LZOM4p";
      case "qa":
        // Borrow Medoma
        return "LZOM4p";
      case "hahag":
        return "68Vqve";
      case "ksgr":
        // For Italian patients, show the Italian feedback form
        if (retrieveBrowserLocale() === "it") {
          return "laaO2W";
        }
        // Default: German
        return "RGrOzJ";
      case "slso":
        return "XxAlbg";
      case "ssh":
        return "obxJAe";
      case "sus":
        return "b5Aa7g";
      default:
        throw organization satisfies never;
    }
  })();

  return useTallyFormIdByOrganization;
};
